/**
 * Icon Component
 *
 * Renders a customizable SVG icon using paths from the Icomoon selection.
 * This component should be the preferred way to include icons in the application
 * as it is accessible for both the app and the generated PDF.
 * The <i> tag gets flagged in Acrobat Pro as a failing tagged content since it uses pseudo-elements.
 *
 * Example usage:
 * <Icon type="search" color="#333" size={24} />
 */
import React from 'react';
import SvgPaths from './SVGPaths';
import selection from '@/fonts/icomoon/selection.json';

export type Props = {
  id?: string;
  color?: string;
  type: string;
  size?: number;
  title?: string;
  margin?: string;
  role?: string;
  decorative?: boolean;
  boxPad?: number;
  className?: string;
  svgClass?: string;
  onMouseEnter?: React.MouseEventHandler<HTMLSpanElement>;
  onMouseLeave?: React.MouseEventHandler<HTMLSpanElement>;
  ['aria-hidden']?: boolean;
  tooltip?: boolean;
};

const Icon = ({ color, type, title, margin, role, decorative, size, boxPad, className, svgClass, tooltip, ...props }: Props) => {
  const iconObj = selection.icons.find((icon: any) => icon.properties && icon.properties.name && icon.properties.name === type);
  const paths = iconObj?.icon?.paths ?? [];
  return (
    <span style={{ display: tooltip ? 'flex' : undefined, margin: margin || '0 4px' }} className={className} {...props}>
      <SvgPaths
        tooltip={tooltip}
        className={svgClass}
        paths={paths}
        size={size || 12}
        boxPad={boxPad || 50}
        fill={color}
        title={title}
        role={role}
        decorative={decorative}
      />
    </span>
  );
};

export default Icon;
